import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MenusAdminComponent } from './menus-admin/menus-admin.component';
import { MenusDialogComponent } from './menus-dialog/menus-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbButtonModule, MdbCheckboxModule, MdbFormsModule, MdbSelectModule, MdbTableModule, MdbTabsModule } from 'mdb5-adapted';
import { LMSSharedUiModule } from '@lmsSharedUI';
import { NgxPaginationModule } from 'ngx-pagination';
import { SubMenuDialogComponent } from './sub-menu-dialog/sub-menu-dialog.component';
import { MenuService } from "src/app/core/rest-services/menu.service";

/**
 * Node for to-do item
 */

export class TodoItemNode {
  children: TodoItemNode[];
  item: string;
}

/** Flat to-do item node with expandable and level information */

export class TodoItemFlatNode {
  item: string;
  level: number;
  expandable: boolean;
}


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MdbSelectModule,
        MdbTabsModule,
        MdbCheckboxModule,
        MdbTableModule,
        MdbFormsModule,
        MdbButtonModule,
        NgxPaginationModule,
        LMSSharedUiModule,
        MenusAdminComponent,
        MenusDialogComponent,
        SubMenuDialogComponent
    ],
    exports: [
        MenusAdminComponent,
        MenusDialogComponent
    ],
    providers: [
        MenuService
    ]
})
export class MenusModule { }
